import React from "react";
// import uniqid from "uniqid";
import { paymentService } from "../../_services/payment.service";
import { orderService } from "../../_services/order.service"; // No longer needed
// import { cartService } from "../../_services/cart.service";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCreditCard } from "@fortawesome/free-solid-svg-icons";

//import createWooCommerceOrder from "./path/to/your/createWooCommerceOrder"; // Adjust the import path

const Paynamics = ({ order: cart, shipping, grandTotal, shippingFee ,userDetails }) => {
  const [isSubmitting, setIsSubmitting] = React.useState(false);

  const handleClick = async () => {
    if (isSubmitting) return;
    setIsSubmitting(true);

    const cartDetails = {
        items: cart.items,
        total: grandTotal,
        shippingFee: shippingFee, // Assuming you have the shipping fee available
        remarks: shipping.remarks,
        first_name: shipping.first_name,
        last_name: shipping.last_name,
        phone: shipping.phone,
        email: shipping.email,
        address_1: shipping.address_1,
        city: shipping.city,
        state: shipping.state,
        country: shipping.country,
        barangay: shipping.barangay,
        zip: shipping.postcode,
        id: userDetails.id || 0,
        shippingDetails: userDetails.shipping || ''
    };

    try {
        // Create the WooCommerce order
        const orderResponse = await orderService.createWooCommerceOrder(cartDetails);
    
        if (orderResponse && orderResponse.id) {
            try {
                // If order creation is successful, initiate Paynamics payment
                const paynamicsUrl = await paymentService.paynamics(orderResponse.id);
        
                // Redirect to the Paynamics payment gateway URL
                window.location.href = paynamicsUrl;
            } catch (error) {
                console.error('Failed to initiate Paynamics payment:', error);
                // Handle the case where payment initiation failed
            }
        } else {
            console.error('Failed to create WooCommerce order:', orderResponse.error);
            // Handle the case where order creation failed
        }
      } catch (error) {
        console.error('Error:', error);
        // Handle any errors that occurred
      } finally {
        setIsSubmitting(false);
      }
  };

  return (
    <button
      style={{
        background: "#313638",
        border: 0,
        color: "rgb(255, 255, 255)",
        height: "48px",
      }}
      className="btn btn-primary btn-lg btn-block btn-paypal m-0 mb-2"
      disabled={isSubmitting}
      onClick={handleClick}
    >
      <FontAwesomeIcon icon={faCreditCard}/> Debit or Credit Card
    </button>
  );
};

export default Paynamics;
